import { useRef, useEffect, useContext } from "react";
//import the Auth Context from global context so I can check if a user is logged in or not.
import AuthContext from "../context/AuthProvider";
//Import the COCO-SSD model from Tensorflow.js
import * as cocossd from "@tensorflow-models/coco-ssd";
//Import the Webcam component to use and render the webcm footage
import Webcam from "react-webcam";
//Import 'Translation' component so I can display it if the user is logged in
import Translation from "../components/Translation";

//According to Tensforlfow.js documentation, these below are both needed in order for the coco-ssd model to load
require("@tensorflow/tfjs-backend-cpu");
require("@tensorflow/tfjs-backend-webgl");

const ScanTranslate = () => {
  //Create an array of guesses in the Global context using useContext that can be added to.
  //const [guesses, setGuesses] = useState([])
  let guesses = [];
  const { setDisplayGuesses } = useContext(AuthContext);
  //console.log(guesses)

  //useRef is a React HOOK that doesn't cause a re-render BUT persists values across renders
  const webcamRef = useRef(null);
  const canvasRef = useRef(null);

  //DEFINE the 'drawBoxes()' function
  const drawBoxes = (detections, drawOnCanvas) => {
    // Loop through each prediction
    detections.forEach((prediction) => {
      // Extract boxes and classes from the predictions array
      const [x, y, width, height] = prediction.bbox; //When it detects an object, TensorflowJS returns a 'bbox' array where it thinks the object is
      const text = prediction.class; //When it detects an object, TensorflowJS returns a 'class' which states what it thinks the object is
      // DRAW outline boxes [the ORDER of all these different DRAWING INSTRUCTIONS is very important]
      drawOnCanvas.strokeStyle = "orange";
      drawOnCanvas.rect(x, y, width, height);
      drawOnCanvas.stroke();
      // DRAW label box [the ORDER of all these different DRAWING INSTRUCTIONS is very important]
      drawOnCanvas.font = "bold 22px Arial";
      drawOnCanvas.textBaseline = "top";
      const textHeight = 22;
      const textPad = 4;
      const textWidth = drawOnCanvas.measureText(text).width;
      drawOnCanvas.fillStyle = "white";
      drawOnCanvas.fillRect(x, y, textWidth + textPad, textHeight + textPad);
      // DRAW label text [the ORDER of all these different DRAWING INSTRUCTIONS is very important]
      drawOnCanvas.fillStyle = "green";
      drawOnCanvas.fillText(text, x, y);
    });
  };

  //DEFINE the 'showDetectedObjects()' function that uses drawBoxes().
  const showDetectedObjects = async (model) => {
    // Check data is available
    if (
      typeof webcamRef.current !== "undefined" &&
      webcamRef.current !== null &&
      webcamRef.current.video.readyState === 4
    ) {
      // Get video properties
      const video = webcamRef.current.video;
      const videoWidth = webcamRef.current.video.videoWidth;
      const videoHeight = webcamRef.current.video.videoHeight;

      // Set the height and width for 'webcamRef' which is used in the 'Webcam' component in the JSX below
      webcamRef.current.video.width = videoWidth;
      webcamRef.current.video.height = videoHeight;

      // Set CANVAS height and width to match the size of the video
      canvasRef.current.width = videoWidth;
      canvasRef.current.height = videoHeight;

      // Make detections/guesses by the AI - THIS IS WHERE COCO-SSD actually makes its predictions
      const aiPredict = await model.detect(video); //return an ARRAY of PREDICTIONS/guesses
      //console.log(aiPredict) //Show the aiPredict object in the console which contains the name of the predicted object

      //Take the AI predictions and add them to a 'guesses' array
      aiPredict.map((prediction) => {
        guesses = [...guesses, prediction.class];
      });
      //Set the displayGuesses in the global Context to be a (unique) set of whatever guesses 'aiPredict' constantly makes...
      //so that the 'Translation' component can use them.
      setDisplayGuesses(Array.from(new Set(guesses)));

      //Get access to the 2D drawing functions that can be used on the canvas (accessed by 'drawOnCanvas.function()' hereafter)
      const drawOnCanvas = canvasRef.current.getContext("2d");

      //Actually DRAW the boxes around the detected objects/predictions (the top guesses from the AI model)
      drawBoxes(aiPredict, drawOnCanvas);
    }
  };

  //DEFINE the 'makeDetections()' function that uses showDetectedObjects().
  const makeDetections = async () => {
    const model = await cocossd.load(); //load the coc-ssd model to be used
    console.log("The COCO-SSD model has been successfully loaded.");
    /*Run the 'Detecting' every 2 seconds (to see if new objects come into view etc) 
      (As a result, the DRAWING on the canvas gets done every two seconds.)*/
    setInterval(() => {
      showDetectedObjects(model); //showDetectedObjects() uses the coco-ssd 'model'
    }, 2000);
  };

  //Run makeDetections() upon initial render of component, using useEffect()
  useEffect(() => {
    makeDetections();
  }, []);

  ////RETURN this JSX to UI (the Webcam component and the CANVAS that has the detected object outlines drawn on it)
  return (
    <div className="container d-flex flex-column">
      <Webcam
        ref={webcamRef}
        muted={true}
        style={{
          position: "absolute",
          marginLeft: "auto",
          marginRight: "auto",
          left: 0,
          right: 0,
          textAlign: "center",
          zindex: 2,
        }}
      />
      <canvas
        ref={canvasRef}
        style={{
          position: "absolute",
          marginLeft: "auto",
          marginRight: "auto",
          left: 0,
          right: 0,
          textAlign: "center",
          zindex: 1,
        }}
      />
      <div style={{ height: "500px" }}></div>{" "}
      {/*This is needed to position my Translation below the ('position:absolute') webcam and canvas.*/}
      <Translation />
    </div>
  );
};

export default ScanTranslate;
